export default function (input: String | string): Uint8Array<ArrayBuffer> {
  if (! String.isString(input))
    throw 'Input missmatch!';
  const padding = (('=').repeat((4 - (input?.length % 4)) % 4));
  const base64 = (input + padding)
    .replace(/-/g, '+') // Replace - with +
    .replace(/_/g, '/'); // Replace _ with /
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i)
    outputArray[i] = rawData.charCodeAt(i);
  return outputArray;
}
